import { digioEnv } from '../../config/constants';

export async function KYCdigioSign(
    requestId: string,
    identifier: string,
    accessToken?: string,
    successFunction?: (response: any) => void,
    cancelFunction?: (response: any) => void
) {
    //@ts-ignore
    const digio = new Digio({
        environment: digioEnv,
        callback: (response: any) => {
            if (response.hasOwnProperty('error_code')) {
                console.error('Error:', response.message);
                cancelFunction?.(response);
            } else {
                console.log('Success:', response);
                successFunction?.(response);
            }
        },
        logo: `${window.location.origin}/offerx-logo.svg`,
        // is_redirection_approach: true,
        // redirect_url: 'https://yourredirecturl.com',
        is_iframe: true,
        theme: {
            primaryColor: '#AB3498',
            secondaryColor: '#000000',
        },
        // event_listener: (event: any) => {
        //     console.log('Event:', event); // Print all events
        // },
        // event_filter: {
        //     events: ['kyc.initiated'], // Example event
        // },
    });
    digio.init();
    digio.submit(requestId, identifier, accessToken);
}
